<template>
    <div class="edit-content" v-if="formLayout.id">
        <div class="nav-link">
            <a class="goToProp" @click="goToPID">{{$t('editProp.backTo')}} #{{editParams.name}}</a>
        </div>
        <!-- <div
            class="tips"
        >Your property will be revalued within 48 hours if you edit information in this section.</div>-->
        <h3 class="subtitle">{{$t('addProperty.Layout')}}</h3>
        <el-form
            :label-position="'left'"
            label-width="108px"
            ref="formLayout"
            :rules="formRuleLayout"
            :model="formLayout"
        >
            <el-form-item class="layout-flex" :label="$t('addProperty.bedrooms')">
                <el-input-number
                    v-model="formLayout.bedrooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.bedrooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-flex" :label="$t('addProperty.bathrooms')">
                <el-input-number
                    v-model="formLayout.bathrooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.bathrooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-flex" :label="$t('addProperty.livingRooms')">
                <el-input-number
                    v-model="formLayout.livingRooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.livingRooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-flex" :label="$t('addProperty.kitchens')">
                <el-input-number
                    v-model="formLayout.kitchens"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.kitchens')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-flex" :label="$t('addProperty.parkingSpaces')">
                <el-input-number
                    v-model="formLayout.parkingSpaces"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.parkingSpaces')"
                ></el-input-number>
            </el-form-item>
            <h3 class="subtitle pt30mb30 border-top">{{$t('addProperty.details')}}</h3>

            <!-- <el-form-item class="specific-label-top"> -->
            <el-row :gutter="16" class="type-card">
                <el-radio-group v-model="formLayout.areaUnit" class="radio-btn">
                    <el-col :span="12">
                        <el-radio label="MT" border>{{$t('addProperty.SQM')}}</el-radio>
                    </el-col>
                    <el-col :span="12">
                        <el-radio label="FT" border>{{$t('addProperty.SQFT')}}</el-radio>
                    </el-col>
                </el-radio-group>
            </el-row>

            <el-row :gutter="8">
                <el-col :span="12">
                    <el-form-item
                        class="p-relative"
                        :label="$t('addProperty.InternalArea')"
                        prop="areaInternal"
                    >
                        <numeric-input type="number" v-model="formLayout.areaInternal"></numeric-input>
                        <span
                            class="append placeholderPend"
                            v-if="formLayout.areaUnit == 'MT'"
                        >{{$t('addProperty.SQM')}}</span>
                        <span
                            class="append placeholderPend"
                            v-if="formLayout.areaUnit == 'FT'"
                        >{{$t('addProperty.SQFT')}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item class="p-relative" :label="$t('addProperty.ExternalArea')">
                        <numeric-input type="number" v-model="formLayout.areaLot"></numeric-input>
                        <span
                            class="append placeholderPend"
                            v-if="formLayout.areaUnit == 'MT'"
                        >{{$t('addProperty.SQM')}}</span>
                        <span
                            class="append placeholderPend"
                            v-if="formLayout.areaUnit == 'FT'"
                        >{{$t('addProperty.SQFT')}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formLayout.propertyType == 3">
                    <el-form-item
                        class="p-relative"
                        :label="formLayout.country == 4 ? $t('addProperty.floor') : $t('addProperty.FloorOptional')"
                        prop="floor"
                    >
                        <numeric-input type="number" v-model="formLayout.floor"></numeric-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formLayout.propertyType == 3">
                    <el-form-item class="p-relative" :label="$t('addProperty.TotalFloor')">
                        <numeric-input type="number" v-model="formLayout.totalFloorsBuilding"></numeric-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item
                :label="$t('property.PurchaseDate')"
                class="p-relative pt20 border-top"
                prop="purchaseDate"
            >
                <el-date-picker
                    v-model="formLayout.purchaseDate"
                    type="date"
                    :placeholder="$t('editProp.selectDatePlaceholder')"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>

            <el-form-item
                :label="$t('property.CompletionDate')"
                class="p-relative pt20"
                prop="completionDate"
            >
                <el-date-picker
                    v-model="formLayout.completionDate"
                    type="date"
                    :placeholder="$t('editProp.selectDatePlaceholder')"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.purchasePrice')"
                class="p-relative pt20 border-top"
                prop="purchasePrice"
            >
                <span class="prepend placeholderPend">{{editParams.currency_symbol}}</span>
                <numeric-input type="number" v-model="formLayout.purchasePrice"></numeric-input>
                <span class="append placeholderPend">{{editParams.currency_code}}</span>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.ownership')"
                class="subtitle p-relative"
                prop="ownershipType"
            >
                <el-row>
                    <el-radio-group v-model="formLayout.ownershipType">
                        <el-col :span="24">
                            <el-radio :label="1">{{$t('addProperty.ownership_Freehold')}}</el-radio>
                        </el-col>
                        <el-col :span="24">
                            <el-radio :label="2">{{$t('addProperty.ownership_Leasehold')}}</el-radio>
                        </el-col>
                    </el-radio-group>
                </el-row>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.totalLength')"
                class="p-relative"
                prop="leaseholdDuration"
                v-if="formLayout.ownershipType == '2'"
            >
                <el-input-number
                    v-model="formLayout.leaseholdDuration"
                    :min="1"
                    :max="100"
                    :label="$t('addProperty.years', {years: formLayout.leaseholdDuration})"
                ></el-input-number>
            </el-form-item>

            <el-form-item class="p-relative">
                <el-button type="primary" @click="updateParam">{{$t('addProperty.confirm')}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { Message } from "element-ui";
import numericInput from "@/components/common/numeric-input.vue";

export default {
    name: "editLayout",
    props: [
        "editParams",
        "requestParams",
        "requestHeaders",
        "portfolioResp",
        "property_info"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            formRuleLayout: {
                areaInternal: {
                    required: true,
                    message: $t("addProperty.internalError"),
                    trigger: ["blur", "change"]
                },
                floor: {
                    required: this.editParams.country == 4 ? true : false,
                    message: $t("addProperty.floorError"),
                    trigger: ["blur", "change"]
                },
                purchasePrice: {
                    required: true,
                    message: $t("addProperty.purchasePriceError"),
                    trigger: ["blur", "change"]
                },
                ownershipType: {
                    required: true,
                    message: $t("addProperty.ownershipError"),
                    trigger: ["blur", "change"]
                }
            },
            formLayout: {
                id: "",
                user: "",
                bedrooms: "",
                bathrooms: "",
                livingRooms: "",
                kitchens: "",
                parkingSpaces: "",
                areaUnit: "",
                areaInternal: "",
                areaLot: "",
                floor: "",
                totalFloorsBuilding: "",
                purchasePrice: "",
                ownershipType: 1,
                leaseholdDuration: 90
            }
        };
    },

    beforeMount() {},

    methods: {
        updateParam() {
            let floorValidate = this.checkFloor();
            if (!floorValidate) {
                return;
            }
            this.$refs["formLayout"].validate(valid => {
                if (!valid) {
                    // this.triggerMessage("error", {
                    //     message: this.$t("addProperty.fieldsError")
                    // });
                } else {
                    this.formLayout.purchasePrice =
                        this.formLayout.purchasePrice * 1;

                    this.$emit("updateParams", {
                        form: this.formLayout,
                        editSelection: "layout"
                    });
                }
            });
        },

        goToPID() {
            this.$emit("goToPID", this.formLayout);
        },

        checkFloor() {
            if (
                this.formLayout.floor != "" &&
                this.formLayout.totalFloorsBuilding != ""
            ) {
                if (
                    this.formLayout.floor > this.formLayout.totalFloorsBuilding
                ) {
                    this.formLayout.floor = "";
                    this.formLayout.totalFloorsBuilding = "";
                    this.triggerMessage("error", {
                        message: this.$t("addProperty.floorBiggerTotal")
                    });
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    components: {
        numericInput
    },

    watch: {
        editParams: {
            handler(newVal, oldVal) {
                this.formLayout.id = newVal.id;
                this.formLayout.user = newVal.user;
                this.formLayout.bedrooms = newVal.bedrooms;
                this.formLayout.bathrooms = newVal.bathrooms;
                this.formLayout.livingRooms = newVal.livingRooms;
                this.formLayout.kitchens = newVal.kitchens;
                this.formLayout.parkingSpaces = newVal.parkingSpaces;
                this.formLayout.areaUnit = newVal.areaUnit;
                this.formLayout.areaInternal = newVal.areaInternal;
                this.formLayout.areaLot = newVal.areaLot;
                this.formLayout.purchasePrice = newVal.purchasePrice;
                this.formLayout.ownershipType = newVal.ownershipType;
                this.formLayout.leaseholdDuration =
                    newVal.leaseholdDuration == 0
                        ? 90
                        : newVal.leaseholdDuration;
                this.formLayout.floor = newVal.floor ? newVal.floor : "";
                this.formLayout.propertyType = newVal.propertyType;
                this.formLayout.country = newVal.country;
                this.formLayout.totalFloorsBuilding = newVal.totalFloorsBuilding
                    ? newVal.totalFloorsBuilding
                    : "";
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
.edit-content {
    width: 400px;
    .layout-flex {
        display: flex;
        justify-content: space-between;
    }
    .goToProp {
        font-family: GothamBook;
        font-size: 14px;
        color: var(--windows-blue);
        &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 12px;
            margin-right: 5px;
            background: url("../../../../website_20/static/img/icon-arrow-l-blue.svg")
                no-repeat;
            background-size: contain;
        }
    }
    .nav-link {
        margin-bottom: 30px;
    }
    // .tips {
    //     border-radius: 4px;
    //     box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
    //     background-color: #203862;
    //     font-family: GothamBook;
    //     font-size: 12px;
    //     line-height: 1.5;
    //     color: var(--white);
    //     padding: 12px 12px 12px 32px;
    //     position: relative;
    //     &::before {
    //         content: "";
    //         display: inline-block;
    //         position: absolute;
    //         width: 12px;
    //         height: 12px;
    //         top: 15px;
    //         left: 12px;
    //         background: url("../../../../website_20/static/img/icon-tips.svg")
    //             no-repeat;
    //         background-size: contain;
    //     }
    // }
    .subtitle {
        font-family: GothamMedium;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: #2e384d;
        margin: 20px 0;
        .el-form-item__label {
            font-family: GothamMedium;
            font-size: 16px;
            font-weight: 500;
            line-height: 1;
            color: #2e384d;
        }
    }
    .pt30mb30 {
        padding-top: 30px;
        margin-bottom: 30px;
        margin-top: 0;
    }
    .pt20 {
        padding-top: 20px;
    }
    .border-top {
        border-top: 1px solid #ebebeb;
    }
    .type-card {
        margin-bottom: 20px;
    }
    .p-relative {
        position: relative;
        .el-form-item__label {
            width: 100% !important;
            margin-bottom: 10px;
            float: unset;
            padding: 0;
            height: auto;
            line-height: normal;
        }
        .el-form-item__content {
            margin: 0 !important;
        }
        .placeholderPend {
            position: absolute;
            top: 0;
            font-size: 14px;
            font-weight: 500;
            color: var(--brownish-grey);
        }
        .append {
            right: 16px;
            font-family: GothamMedium;
        }
        .prepend {
            left: 16px;
            font-family: GothamBook;
        }
    }
    .el-radio-group.radio-btn {
        width: 100%;
        .el-radio {
            border: 1px solid #e0e7ff;
            text-align: center;
            width: 100%;
            &.is-checked {
                background-color: var(--windows-blue);
                border-color: var(--windows-blue);
                .el-radio__label {
                    font-family: GothamBook;
                    color: var(--white);
                }
            }
            .el-radio__inner {
                display: inline;
                width: 0;
                height: 0;
                overflow: hidden;
                border: 0;
                &::after {
                    content: unset;
                }
            }
            .el-radio__label {
                font-family: GothamBook;
                font-size: 14px;
                letter-spacing: -0.1px;
                text-align: center;
                color: var(--windows-blue);
            }
        }
    }
    .el-radio {
        &.is-checked {
            .el-radio__label {
                font-family: GothamBook;
                font-size: 14px;
                letter-spacing: -0.1px;
                text-align: center;
                color: var(--windows-blue);
            }
        }
        .el-radio__input.is-checked .el-radio__inner {
            background-color: var(--windows-blue);
            color: var(--windows-blue);
            border-color: var(--windows-blue);
        }
        .el-radio__label {
            font-family: GothamBook;
        }
    }
    .el-input {
        &.is-focus {
            .el-input__inner {
                border: 1px solid var(--windows-blue);
            }
        }
    }
    .el-input__inner {
        background-color: rgba(224, 231, 255, 0.2);
        padding-left: 40px;
        &:focus {
            border: 1px solid var(--windows-blue);
        }
    }
    .el-button {
        margin-top: 30px;
        width: 100%;
        background-color: var(--windows-blue);
        border: 0;
    }
    .el-checkbox {
        .el-checkbox__input {
            &.is-focus {
                .el-checkbox__inner {
                    border-color: var(--windows-blue);
                }
            }
        }
        &.is-checked {
            .el-checkbox__inner {
                background: var(--windows-blue);
                border-color: var(--windows-blue);
            }
            .el-checkbox__label {
                color: var(--windows-blue);
            }
        }
    }
    .el-input-number {
        .el-input-number__increase,
        .el-input-number__decrease {
            background-color: rgba(224, 231, 255, 0.2);
        }

        &.is-focus {
            .el-checkbox__inner {
                border-color: var(--windows-blue);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/editLayout.vue